import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../MyContexts/Users_Context';

const UserPermission = (props) => {

    const [user, setUser] = useContext(UserContext);
    const [orderStatus, setUserPermiss] = useState((props.permiss != null) ? props.permiss : "צופה");
    const [colorforStat, setColorforStat] = useState("");

    useEffect(() => {
        setUserPermiss(props.UserPermiss)

    }, [props.UserPermiss])

    const handleChange = (e) => {
        setUserPermiss(e.target.value)
        props.setUserPermiss(e.target.value)

    }

    return (
        <span className={`${colorforStat} 'pointing' `}>
            <select
                className={`onRight selectInBlock`}
                value={orderStatus}
                onChange={handleChange}>
                <option value={"watch"}>צופה</option>
                <option value={"restAdmin"}>מנהל מסעדה</option>
                <option value={"restUser"}>עובד מסעדה</option>
                <option value={"deliver"} >שליח</option>
                <option value={"blocked"} >חסום</option>
                {user.permiss == "admin" ? <option value={"admin"} >אדמין</option> : ""}
            </select>
        </span>
    );
}

export default UserPermission;